import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Button as Button$1 } from '@mui/base';
import { styled } from '@mui/material';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { shouldForwardPropHelper } from '../../utils/shouldForwardHelper.js';
import '../Icons/Add.js';
import '../Icons/Application.js';
import '../Icons/AppStore.js';
import '../Icons/Arrow.js';
import '../Icons/At.js';
import '../Icons/Attach.js';
import '../Icons/Bank.js';
import '../Icons/Battery.js';
import '../Icons/Bell.js';
import '../Icons/Blocked.js';
import '../Icons/Calendar.js';
import '../Icons/Card.js';
import '../Icons/CaretDown.js';
import '../Icons/CaretLeft.js';
import '../Icons/CaretRight.js';
import '../Icons/CaretUp.js';
import '../Icons/Checkbox.js';
import '../Icons/CheckboxChecked.js';
import '../Icons/CheckboxIndeterminate.js';
import '../Icons/ChevronLeft.js';
import '../Icons/ChevronRight.js';
import '../Icons/Company.js';
import '../Icons/Copy.js';
import '../Icons/Currency.js';
import '../Icons/Customers.js';
import '../Icons/Dash.js';
import '../Icons/Dashboard.js';
import DirectionDown from '../Icons/DirectionDown.js';
import '../Icons/DirectionUp.js';
import '../Icons/Document.js';
import '../Icons/DoubleChevronLeft.js';
import '../Icons/DoubleChevronRight.js';
import '../Icons/DoubleDirectionDown.js';
import '../Icons/DoubleDirectionUp.js';
import '../Icons/Download.js';
import '../Icons/Edit.js';
import '../Icons/ExclamationMark.js';
import '../Icons/ExclamationMarkFilled.js';
import '../Icons/ExternalLink.js';
import '../Icons/EyeClosed.js';
import '../Icons/EyeOpen.js';
import '../Icons/Fingerprint.js';
import '../Icons/Folder.js';
import '../Icons/Forever.js';
import '../Icons/Funnel.js';
import '../Icons/GooglePlay.js';
import '../Icons/Iban.js';
import '../Icons/Id.js';
import '../Icons/Info.js';
import '../Icons/InfoFilled.js';
import '../Icons/Instant.js';
import '../Icons/Ip.js';
import '../Icons/Link.js';
import '../Icons/List.js';
import '../Icons/Mail.js';
import '../Icons/Menu.js';
import '../Icons/Message.js';
import '../Icons/MessageDot.js';
import '../Icons/Onboarding.js';
import '../Icons/Padlock.js';
import '../Icons/PadlockOpen.js';
import '../Icons/Percent.js';
import '../Icons/Play.js';
import '../Icons/PowerOff.js';
import '../Icons/ProcessCompleted.js';
import '../Icons/ProcessCountEight.js';
import '../Icons/ProcessCountFive.js';
import '../Icons/ProcessCountFour.js';
import '../Icons/ProcessCountNineAndMore.js';
import '../Icons/ProcessCountOne.js';
import '../Icons/ProcessCountSeven.js';
import '../Icons/ProcessCountSix.js';
import '../Icons/ProcessCountThree.js';
import '../Icons/ProcessCountTwo.js';
import '../Icons/ProcessFailed.js';
import '../Icons/ProcessInProgress.js';
import '../Icons/ProcessNotStarted.js';
import '../Icons/ProcessPartialInProgress.js';
import '../Icons/ProcessPaused.js';
import '../Icons/Profile.js';
import '../Icons/Progress.js';
import '../Icons/Provider.js';
import '../Icons/QuestionMark.js';
import '../Icons/QuestionMarkFilled.js';
import '../Icons/Remove.js';
import '../Icons/Repeat.js';
import '../Icons/Reset.js';
import '../Icons/RoundArrow.js';
import '../Icons/RoundArrowFilled.js';
import '../Icons/RoundCheckOutlined.js';
import '../Icons/RoundCheckOutlinedFilled.js';
import '../Icons/RoundClose.js';
import '../Icons/RoundCloseFilled.js';
import '../Icons/RoundLeft.js';
import '../Icons/RoundLeftFilled.js';
import '../Icons/RoundMinus.js';
import '../Icons/RoundMinusFilled.js';
import '../Icons/RoundPlus.js';
import '../Icons/RoundPlusFilled.js';
import '../Icons/RoundRight.js';
import '../Icons/RoundRightFilled.js';
import '../Icons/Settings.js';
import '../Icons/SettingsCog.js';
import '../Icons/Shield.js';
import '../Icons/StarFilled.js';
import '../Icons/StarOutlined.js';
import '../Icons/Success.js';
import '../Icons/Timer.js';
import '../Icons/Trash.js';
import '../Icons/Upload.js';
import '../Icons/User.js';
import '../Icons/VerticalDots.js';
import '../Icons/World.js';
import '../Icons/Wrench.js';
import '../Icons/Zoom.js';

const CLASSES = {
    button: "VoltButton-root",
    buttonLoading: "VoltButton-loading",
};
const PROPS_SET = new Set([
    "variant",
    "color",
    "size",
    "startIcon",
    "dropdown",
    "loading",
    "fullWidth",
    "buttonDisabled",
]);
const ButtonRoot = styled("button", {
    name: "VoltButton",
    slot: "Root",
    shouldForwardProp: (prop) => shouldForwardPropHelper(prop, PROPS_SET),
})(({ theme, variant, size, color, loading, fullWidth, buttonDisabled }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", position: "relative", cursor: "pointer", borderRadius: theme.shape.borderRadius, textDecoration: "none", verticalAlign: "middle", transition: `
      background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
      outline 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms
    `, padding: theme.spacing(0, 1), "& > *": {
        letterSpacing: "normal",
    }, "&:disabled": {
        pointerEvents: "none",
        cursor: "default",
        opacity: 0.4,
    } }, (buttonDisabled && {
    pointerEvents: "none",
    cursor: "default",
    opacity: 0.4,
})), (loading && {
    pointerEvents: "none",
    ["*"]: {
        visibility: "hidden",
    },
    [ButtonLoading]: {
        visibility: "visible",
        zIndex: 1,
        [LoadingDot]: {
            visibility: "visible",
        },
    },
})), { [`${StartIconRoot} *:nth-of-type(1)`]: {
        fontSize: 16,
    }, [`${EndIconRoot} *:nth-of-type(1)`]: {
        fontSize: 16,
    } }), (size === "small" && Object.assign(Object.assign({ minHeight: 24 }, theme.typography.buttonSmall), { [Text]: {
        padding: 0,
    }, [StartIconRoot]: {
        margin: "0 2px 0 -4px",
    }, [`${EndIconRoot} *:nth-of-type(1)`]: {
        margin: "0 -4px 0 2px",
    } }))), (size === "medium" && Object.assign({ minHeight: 36 }, theme.typography.buttonMedium))), (size === "large" && Object.assign(Object.assign({ minHeight: 48, padding: theme.spacing(0, 2) }, theme.typography.buttonLarge), { [LoadingDot]: {
        width: 8,
        height: 8,
        borderRadius: 6,
        margin: theme.spacing(0, 0.5),
    }, [ButtonLoading]: {
        margin: "0 -3px",
    } }))), (variant === "solid" && Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ backgroundColor: theme.palette.primary[800], color: theme.palette.text.white, "&:focus": {
        outline: `2px solid ${theme.palette.primary[400]}`,
        outlineOffset: 1,
    }, "&:hover": {
        backgroundColor: theme.palette.primary.hover,
    }, "&:active": {
        backgroundColor: theme.palette.primary[800],
        boxShadow: `
        0px 2px 2px rgba(3, 100, 255, 0.2),
        0px 4px 8px rgba(32, 37, 43, 0.2)
    `,
    } }, (color === "accent" && {
    backgroundColor: theme.palette.success[500],
    "&:hover": {
        backgroundColor: theme.palette.success.hover,
    },
    "&:active": {
        backgroundColor: theme.palette.success[500],
        boxShadow: `
          0px 2px 2px rgba(30, 168, 163, 0.2),
          0px 4px 8px rgba(32, 37, 43, 0.2)
        `,
    },
})), (color === "danger" && {
    backgroundColor: theme.palette.failure[700],
    "&:hover": {
        backgroundColor: theme.palette.failure.hover,
    },
    "&:active": {
        backgroundColor: theme.palette.failure[700],
        boxShadow: `
          0px 2px 2px rgba(219, 28, 28, 0.2),
          0px 4px 8px rgba(32, 37, 43, 0.2)
        `,
    },
})), ((color === "ghost" || color === "ghost-blue") && {
    "&:active": {
        backgroundColor: "transparent",
    },
    "&:disabled": {
        backgroundColor: "transparent",
        opacity: 0.4,
    },
})), (color === "ghost" && {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    color: theme.palette.ui10,
    "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.45)",
    },
})), (color === "ghost-blue" && {
    backgroundColor: "rgba(27, 99, 207, 0.1)",
    color: theme.palette.primary.main,
    "&:hover": {
        backgroundColor: "rgba(27, 99, 207, 0.25)",
    },
})))), (variant === "outlined" && Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ backgroundColor: theme.palette.ui10, border: `1px solid ${theme.palette.primary[800]}`, color: theme.palette.primary[800] }, (size === "medium" && {
    padding: 7,
})), (size === "large" && {
    padding: 11,
})), { "&:focus": {
        outline: `2px solid ${theme.palette.primary[400]}`,
    }, "&:hover": {
        backgroundColor: theme.palette.primary[800],
        color: theme.palette.text.white,
    }, "&:active": {
        backgroundColor: theme.palette.ui10,
        color: theme.palette.primary[800],
        boxShadow: `
        0px 2px 2px rgba(3, 100, 255, 0.15),
        0px 4px 8px rgba(32, 37, 43, 0.15)
      `,
    }, [LoadingDot]: {
        backgroundColor: theme.palette.primary[800],
    } }), (color === "grey" && {
    backgroundColor: theme.palette.ui12,
    border: `1px solid ${theme.palette.ui50}`,
    color: theme.palette.text.medium,
    "&:hover": {
        backgroundColor: theme.palette.ui50,
        color: theme.palette.text.medium,
    },
    "&:active": {
        backgroundColor: theme.palette.ui12,
        color: theme.palette.text.medium,
        boxShadow: `
          0px 2px 2px rgba(3, 100, 255, 0.15),
          0px 4px 8px rgba(32, 37, 43, 0.15)
        `,
    },
    [LoadingDot]: {
        backgroundColor: theme.palette.ui50,
    },
})), (color === "accent" && {
    backgroundColor: theme.palette.ui12,
    border: `1px solid ${theme.palette.success[500]}`,
    color: theme.palette.success[500],
    "&:hover": {
        backgroundColor: theme.palette.success[500],
        color: theme.palette.text.white,
    },
    "&:active": {
        backgroundColor: theme.palette.ui12,
        color: theme.palette.success[500],
        boxShadow: `
          0px 2px 2px rgba(30, 168, 163, 0.2),
          0px 4px 8px rgba(32, 37, 43, 0.2)
        `,
    },
    [LoadingDot]: {
        backgroundColor: theme.palette.success[500],
    },
})), (color === "danger" && {
    backgroundColor: theme.palette.ui12,
    border: `1px solid ${theme.palette.failure[700]}`,
    color: theme.palette.failure[700],
    "&:hover": {
        backgroundColor: theme.palette.failure[700],
        color: theme.palette.text.white,
    },
    "&:active": {
        backgroundColor: theme.palette.ui12,
        color: theme.palette.failure[700],
        boxShadow: `
        0px 2px 2px rgba(219, 28, 28, 0.2),
        0px 4px 8px rgba(32, 37, 43, 0.2)
        `,
    },
    [LoadingDot]: {
        backgroundColor: theme.palette.failure[700],
    },
})))), (variant === "text" && {
    color: theme.palette.primary.main,
    backgroundColor: "transparent",
    padding: 0,
    letterSpacing: 0,
    fontWeight: 400,
    "&:hover": {
        backgroundColor: "transparent",
        textDecoration: "underline",
    },
    "&:focus": {
        outline: "none",
        textDecoration: "underline",
    },
    "&:active": {
        backgroundColor: "transparent",
        color: theme.palette.primary.main,
        boxShadow: "none",
    },
})), (fullWidth && {
    minWidth: "100%",
}))));
const ButtonComponent = forwardRef(function ButtonComponent(_a, ref) {
    var { startIcon, endIcon, dropdown, loading = false, disabled = false, children, className, component, variant = "solid", color = "default", size = "medium", sxText } = _a, rest = __rest(_a, ["startIcon", "endIcon", "dropdown", "loading", "disabled", "children", "className", "component", "variant", "color", "size", "sxText"]);
    return (jsxs(Button$1, Object.assign({ as: component, buttonDisabled: disabled, className: clsx(CLASSES.button, className, { [CLASSES.buttonLoading]: loading }), color: color, ref: ref, size: size, variant: variant, slots: {
            root: ButtonRoot,
        } }, rest, { disabled: disabled, loading: loading, children: [loading && (jsxs(ButtonLoading, { children: [jsx(LoadingDot, {}), jsx(LoadingDot, {}), jsx(LoadingDot, {})] })), startIcon && jsx(StartIconRoot, { children: startIcon }), jsx(Text, { sx: sxText, children: children }), endIcon && jsx(EndIconRoot, { sx: { marginRight: 1 }, children: endIcon }), dropdown && (jsx(EndIconRoot, { children: jsx(DirectionDown, { fontSize: "small" }) }))] })));
});
/** Primary UI for user interaction */
const Button = ButtonComponent;
const LoadingDot = styled("div")(({ theme }) => ({
    background: theme.palette.ui10,
    width: 6,
    height: 6,
    borderRadius: 3,
    margin: "0 2px",
    visibility: "visible",
    animation: "dots 1.5s infinite",
    "&:nth-child(2)": {
        animationDelay: "500ms",
    },
    "&:nth-child(3)": {
        animationDelay: "1000ms",
    },
    "@keyframes dots": {
        "0%": {
            opacity: 1,
        },
        "30%": {
            opacity: 0.25,
        },
        "70%": {
            opacity: 0.5,
        },
        "100%": {
            opacity: 1,
        },
    },
}));
const Text = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 1),
}));
const ButtonLoading = styled("div")({
    display: "flex",
    flexWrap: "nowrap",
    margin: "0 -2px",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    visibility: "visible",
    inset: 0,
});
const StartIconRoot = styled("span", {
    name: "VoltButton",
    slot: "StartIcon",
})(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(1),
}));
const EndIconRoot = styled("span", {
    name: "VoltButton",
    slot: "EndIcon",
})({
    display: "flex",
    alignItems: "center",
});

export { Button, ButtonRoot, CLASSES };
//# sourceMappingURL=Button.js.map
